import React, { useState, memo } from 'react';
import { Platform, Text, View } from 'react-native';
import Images from '../../constants/Images';
import { Marker } from 'react-native-maps';
import { Marker as WebMarker } from 'react-google-maps';
import IconMap from '../../constants/IconMap';

const PointMarker = ({ latitude, longitude, icon, ...rest }) => {
  const [showInfo, setShowInfo] = useState(false);

  if (Platform.OS === 'web') {
    return (
      <WebMarker
        tracksViewChanges={false}
        onClick={() => setShowInfo(!showInfo)}
        icon={{
          scaledSize: {
            width: 48,
            height: 72,
          },
          url: Images.markerAndroid.marker,
        }}
        position={{
          lat: latitude,
          lng: longitude,
        }}
        label={{
          text: IconMap[icon],
          color: '#fff',
          fontSize: '26px',
          fontFamily: 'tripeasy',
        }}
        {...rest}
      >
        {showInfo && <View></View>}
      </WebMarker>
    );
  } else {
    if (Platform.OS === 'ios') {
      return (
        <Marker
          coordinate={{
            latitude: latitude,
            longitude: longitude,
          }}
          centerOffset={{ x: 0, y: -25 }}
          image={Images.marker.marker_large}
          tracksViewChanges={false}
          {...rest}
        ></Marker>
      );
    } else {
      return (
        <Marker
          coordinate={{
            latitude: latitude,
            longitude: longitude,
          }}
          image={Images.marker.marker_large}
          tracksViewChanges={false}
          {...rest}
        ></Marker>
      );
    }
  }
};

export default memo(PointMarker);
